import React, { useEffect, useState } from "react";
import { Upload, Image } from "antd";
import ImgCrop from "antd-img-crop";

const ImageUploader = ({ fileList, setFileList }) => {
  const [preview, setPreview] = useState(null);

  const onChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const onPreview = async (file) => {
    const url = URL.createObjectURL(file.originFileObj);
    setPreview(url);
  };

  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  useEffect(() => {
    return () => {
      preview && URL.revokeObjectURL(preview);
    };
  }, [preview]);
  return (
    <>
      {/* CROP ẢNH */}
      <ImgCrop
        rotationSlider
        quality={0.9} // chất lượng ảnh sau crop
        aspectSlider
        modalOk="Tải"
        modalCancel="Hủy"
        aspect={4 / 3}
        beforeUpload={() => false}
      >
        <Upload
          maxCount={2}
          listType="picture-card"
          fileList={fileList}
          onChange={onChange}
          onPreview={onPreview}
          customRequest={dummyRequest}
        >
          {fileList.length < 2 && "+ Tải lên"}
        </Upload>
      </ImgCrop>

      {/* PREVIEW ẢNH */}

      {preview && (
        <Image
          style={{ display: "none" }}
          preview={{
            visible: true,
            src: preview,
            onVisibleChange: (visible) => {
              if (!visible) setPreview(null);
            },
          }}
        />
      )}
    </>
  );
};

export default ImageUploader;
